<div id="pre-bootstrap-container" >
  <div id="pre-bootstrap" [ngClass]="{'show-bg': !user.isPatientTask}">
    <div class="messaging">
      <span class="loader"></span>
    </div>
  </div>
</div>
